import React, { useEffect, useState } from 'react';
import { Col, Form, Input, Row, Button, Divider, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getPharmacyId } from '../../components/Shared';
import { sendData, sendDataPut } from '../../httpRequests';

const { TextArea } = Input;

export default function Profile() {
	const navigate = useNavigate();
	const [pharmacy, setPharmacy] = useState({});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		const pharmacyId = getPharmacyId();
		if (!pharmacyId) {
			navigate('/login');
			return false;
		}

		const url = '/pharmacies/getPharmacyById';
		const data = {
			id: pharmacyId
		};
		sendData(url, data).then((response) => {
			const pharmacy = response['pharmacy'];
			setPharmacy(pharmacy);
		});
	}, []);

	const validateFile = ({ file, onSuccess, onError }) => {
		if (['image/png', 'image/jpeg'].includes(file.type) && file.size <= 2097152) {
			onSuccess(true);
			uploadPharmacyPicture(file);
		} else onError(true);
	};

	const uploadPharmacyPicture = (profilePicture) => {
		let formData = new FormData();
		formData.append('image', profilePicture);

		const url = '/pharmacies/updatePharmacyPhoto/' + pharmacy.id;

		sendDataPut(url, formData).then((response) => {
			if (Object.keys(response).length > 0) {
				window.location.reload();
			}
		});
	};

	const updatePharmacyProfile = (values) => {
		setIsLoading(true);
		const url = '/pharmacies/updatePharmacy';
		const data = {
			id: pharmacy.id,
			email: values.email,
			npi: pharmacy.npi,
			secret_key: pharmacy.npi,
			name: values.name,
			address: values.address,
			city: values.city,
			phone: values.phone,
			zip: values.zip,
			account_name: values.account_name,
			bank_account: values.bank_account,
			banking_institute: values.banking_institute,
			route_number: values.route_number,
			driver_status: pharmacy.driver_status,
			dispatcher: values.dispatcher,
			placeOfDispatch: values.placeOfDispatch,
			dispatcherPhone: values.dispatcherPhone
		};
		sendData(url, data).then((response) => {
			setIsLoading(false);
			if (Object.keys(response).length > 0) {
				Swal.fire({
					text: response['message'],
					icon: 'success',
					confirmButtonColor: '#128780'
				}).then(() => window.location.reload());
			}
		});
	};

	return (
		<div>
			{Object.keys(pharmacy).length > 0 && (
				<Form layout='vertical' onFinish={updatePharmacyProfile}>
					<div>
						<h2 style={{ marginBottom: 30 }}>Contact information</h2>
						<Row>
							<Col span={12}>
								<Form.Item label='Profile picture' valuePropName='file'>
									<Upload maxCount={1} listType='picture' customRequest={validateFile}>
										<Button icon={<UploadOutlined />}>Upload Profile Picture</Button>
									</Upload>
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.email}
									label='Email'
									name='email'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='email' autoCapitalize='false' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.name}
									label='Name'
									name='name'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.phone}
									label='Phone'
									name='phone'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='phone' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.address}
									label='Address'
									name='address'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='address' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.zip}
									label='Zip Code'
									name='zip'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.city}
									label='City'
									name='city'
									rules={[
										{
											required: true
										}
									]}
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.bank_account}
									label='Bank account'
									name='bank_account'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.banking_institute}
									label='Banking institute'
									name='banking_institute'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
						</Row>
						<Row gutter={24}>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.account_name}
									label='Account name'
									name='account_name'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.route_number}
									label='Route number'
									name='route_number'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.dispatcher}
									label='Dispatcher contact name'
									name='dispatcher'
								>
									<Input size='large' type='text' />
								</Form.Item>


							</Col>

							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.dispatcherPhone}
									label='Dispatcher extension number'
									name='dispatcherPhone'
								>
									<Input size='large' type='text' />
								</Form.Item>
							</Col>
							<Col span={12}>
								<Form.Item
									initialValue={pharmacy.placeOfDispatch}
									label='Place of dispatch'
									name='placeOfDispatch'
								>
									 <TextArea rows={4} />
								</Form.Item>
							</Col>
						</Row>
					</div>
					<Divider />
					<Row gutter={24} style={{ marginTop: 50 }}>
						<Col span={24}>
							<Form.Item>
								<Button
									type='primary'
									htmlType='submit'
									loading={isLoading}
									disabled={isLoading}
									style={{ borderRadius: 10, width: '100%', backgroundColor: '#128780' }}
									size='large'
								>
									Save changes
								</Button>
							</Form.Item>
						</Col>
					</Row>
				</Form>
			)}
		</div>
	);
}
